import { TAppealsInfoDataGridResult } from "./useAppealInfoDataGrid";

export const useAppealInfoDataGridColumns = (
  gridData: TAppealsInfoDataGridResult
) => {
  return gridData.gridProps.columns.concat([]);
};
